import "./ScrollingLogos.css";

import logo1 from "/assets/logo1.png";
import logo2 from "/assets/logo2.png";
import logo3 from "/assets/logo3.png";
import logo4 from "/assets/logo4.png";
import logo5 from "/assets/logo5.png";

const ScrollingLogos = () => {
  const logos = [logo1, logo2, logo3, logo4, logo5];

  return (
    <div className="scrolling-logos">
      <div className="logos-container">
        {[...logos, ...logos].map((logo, index) => (
          <img key={index} src={logo} alt={`Logo ${index}`} className="logo" />
        ))}
      </div>
    </div>
  );
};

export default ScrollingLogos;
